import React from 'react'
import { useParams } from 'react-router-dom'
import { Grid } from '@mui/material'

import { useGetB2CPaymentsItem } from '../../services'
import { DataBlock, FetchErrorMessage, ViewPaymentSkeleton } from '../../components'

import { MAIN_INFO_LABELS, MONEY_INFO_LABELS, RCV_INFO_LABELS } from './constants.ts'

export const B2CViewPage = (): React.ReactElement => {
  const { id = '' } = useParams<{ id: string }>()
  const { data, isRefetching, refetch, isError, isLoading } = useGetB2CPaymentsItem(id)

  if (!data?.data.transferId || isLoading) return <ViewPaymentSkeleton />

  return (
    <FetchErrorMessage isFetching={isRefetching} isError={isError} refetch={refetch}>
      <Grid container flexDirection="row" spacing={{ xs: 2, lg: 4 }}>
        <Grid item xs={12} md={6}>
          <DataBlock items={MAIN_INFO_LABELS} data={data.data} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={RCV_INFO_LABELS} data={data.data} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={MONEY_INFO_LABELS} data={data.data} />
        </Grid>
      </Grid>
    </FetchErrorMessage>
  )
}
